import { AfterViewInit, Component, HostBinding, HostListener, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { TrimFormControl } from '../../form-controls/trim-form-control.form-control';
import { ProductReleaseCommentDialogService } from './product-release-comment-dialog.service';

@Component({
  selector: 'prism-product-release-comment-dialog',
  templateUrl: './product-release-comment-dialog.component.html',
  styleUrls: ['./product-release-comment-dialog.component.scss'],
})

export class ProductReleaseCommentDialogComponent implements OnInit, AfterViewInit {

  public dialogWidth$: BehaviorSubject<number> = new BehaviorSubject<number>(800);
  public dialogLeftPosition$: BehaviorSubject<number> = new BehaviorSubject<number>(0);


  formGroup: FormGroup<{
    changes: TrimFormControl<string>,
  }> = new FormGroup({
    changes: new TrimFormControl<string>('', Validators.required),
  });

  constructor(
    public dialogService: ProductReleaseCommentDialogService
  ) { }

  ngOnInit(): void {
    if (!!this.dialogService.aiComment$.value) {
      this.formGroup.controls.changes.setValue(this.dialogService.aiComment$.value)
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.updateWidth();
    });
  }

  @HostBinding('style.--child-scale')
  get childScale() {
    return this.dialogService.styleVariableScale; // Return the input value
  }


  // resize
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updateWidth();
  }


  public submitResponse() {

    if (this.formGroup.valid) {
      const comment = `Changes:\n${this.formGroup.controls.changes.value}`

      let response = {
        comment,
      }

      this.dialogService.response$.next(response)
    }
  }

  private updateWidth() {
    const screenWidth = window.innerWidth;

    if (screenWidth < 800) {
      this.dialogWidth$.next(screenWidth * 0.9);
    } else {
      this.dialogWidth$.next(800 * this.dialogService.styleVariableScale);
    }

    this.dialogLeftPosition$.next((screenWidth - this.dialogWidth$.value) / 2);
  }

  public cancel() {
    this.dialogService.destroyDialog();
  }


}